import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ClientDTO } from 'tekkeys-common';

export interface CollaboratorsState extends EntityState<ClientDTO> {}

export const collaboratorsAdapter: EntityAdapter<ClientDTO> = createEntityAdapter<ClientDTO>();
